import {MiniEvent} from "@cdx/common";
import {BoundingBoxStore, BushRect, PosRef} from "./canvas-utils";
import {RefObject, useRef, useState} from "react";
import {useDSDimensionCallbackWithStableRef} from "@cdx/ds/hooks/position-hooks";

export interface MyBoundingBoxStore extends BoundingBoxStore {
  boxUpdated: () => void;
}

const PADDING = 10;

const createBboxStore = (
  posRef: PosRef,
  measureRef: React.MutableRefObject<[number, number] | null>
): MyBoundingBoxStore => {
  const toSnapshot = () => {
    const minX = -posRef.current.x;
    const minY = -posRef.current.y;
    const [width, height] = measureRef.current ?? [0, 0];
    return {
      minX: minX - PADDING,
      minY: minY - PADDING,
      maxX: minX + width / posRef.current.scale + PADDING,
      maxY: minY + height / posRef.current.scale + PADDING,
    };
  };
  let snapshot = toSnapshot();
  const miniEvent = new MiniEvent<BushRect>();
  const bboxStore: MyBoundingBoxStore = {
    getSnapshot: () => snapshot,
    subscribe: miniEvent.addListener,
    boxUpdated: () => {
      snapshot = toSnapshot();
      miniEvent.emit();
    },
  };
  return bboxStore;
};

export const useBBox = (posRef: PosRef, wrapperRef: RefObject<HTMLDivElement | null>) => {
  const measureRef = useRef<[number, number]>([100, 100]);
  const [bboxStore] = useState(() => createBboxStore(posRef, measureRef));
  useDSDimensionCallbackWithStableRef(wrapperRef, ({width, height}) => {
    measureRef.current = [width, height];
    bboxStore.boxUpdated();
  });
  return {measureRef, bboxStore};
};
